import { BASE_URL } from "../../App";

export const getUserData = async (userId, token = null) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/vieraskirja/id/${userId}`,
      {
        method: "GET",
        headers: headers,
      }
    );
    if (!response.ok) {
      throw new Error("Käyttäjänimen haku epäonnistui");
    }
    return await response.json();
  } catch (error) {
    console.log("Virhe käyttäjän statuksen tarkistuksessa:", error);
    return null;
  }
};
